import axios from 'axios'
import KeycloakService from '../utils/keycloakService'
import {
  mobileText,
  radiologyIntents,
  service,
} from '../features/Radiology/Constants/constants'
import { Patient } from 'fhir/r4'
import { makeName } from '../features/lms/utils'
import {
  FetchRadiologyTestPriceParams,
  RadiologyOrders,
} from '../features/Radiology/models'
import { startSxpProxy } from '../utils/api'
import {
  archiveradiology,
  deleteradiology,
  getRadiologyOrdersByUhid,
  IPD_PROJECT_ID,
  LABS_PROJECT_ID,
  RADIOLOGY_PROJECT_ID,
} from '../utils/constants'
import {
  DELETE_DOCUMENT_BY_ID,
  radiologySearchEndpoint,
} from '../utils/Endpoints'
import { dropDownMenuKeys } from '../components/constants'
import { priceListNotFound } from '../features/labTests/models'
import { getOdooProductPrice } from './LmsService'
import {
  RADIOLOGY_FILE_UPLOAD_ENDPOINT,
  RADIOLOGY_GET_DOCUMENTS_ENDPOINT,
} from '../features/bedManagement/endpoints/EndPoints'
import { toast } from 'react-toastify'
import { ERROR_DELETE_DOCUMENT } from './constants'

export const sendWhatsAppMessage = async (body: any): Promise<any> => {
  const token = KeycloakService.getToken()

  try {
    const response: any = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${radiologyIntents?.sendNotification}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    console.error('Error fetching assigned patient for bed: ', error)
    return {
      success: false,
      error: error?.message,
    }
  }
}
export const notificationUpload = async (
  blobData: Blob,
  patient: Patient | null,
  order: RadiologyOrders | null
): Promise<any> => {
  const name = makeName(patient?.name)
  const mobile = patient?.telecom?.find(
    (prt: any) => prt?.use === mobileText
  )?.value
  const preferenceCommunication = patient?.telecom?.find(
    (e: any) => e?.system === service?.sms
  )
  const preference =
    preferenceCommunication?.value === service?.yes
      ? service?.SMS
      : service?.WHATSAPP
  try {
    const token = sessionStorage.getItem('react-token')

    const formData = new FormData()
    formData.append(service?.stateId, service?.stateIdValue)
    formData.append(service?.preference, preference)
    formData.append(service?.sendTo, `91${mobile}`)
    formData.append(service?.location, `${order?.source}`)
    formData.append(service?.name, `${name}`)
    formData.append(service?.sourceType, service?.radiology)
    formData.append(service?.file, blobData, `${name}_${order?.id}.pdf`)

    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${radiologyIntents?.notificationUpload}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      }
    )

    if (response?.status === 200) {
      return response.data
    } else {
      return { fileId: '' }
    }
  } catch (error) {
    console.error(error)
  }
}

export const updateRadiologyOrderWithDocId = async (
  orderId: any,
  docId: any,
  dmsUploadRetry: boolean
) => {
  if (!orderId) {
    throw new Error('Order ID is required')
  }

  const state: any = {
    id: orderId,
    dmsUploadRetry: dmsUploadRetry,
  }
  if (docId && docId !== '') {
    state.docId = docId
  }

  try {
    const response = await startSxpProxy(
      RADIOLOGY_PROJECT_ID,
      radiologyIntents?.updateRadiologyOrderWithDocId,
      state
    )
    return response
  } catch (error) {
    console.error('Error updating radiology order:', error)
    throw error
  }
}
export const sendNotificationReport = async (blobData: Blob, item: any) => {
  try {
    const token = sessionStorage.getItem('react-token')

    const formData = new FormData()
    formData.append(service?.stateId, item?.id)
    formData.append(service?.preference, item?.patientCommunication)
    formData.append(service?.sendTo, `91${item?.patientMobile}`)
    formData.append(service?.location, `${item?.source}`)
    formData.append(service?.name, `${item?.patientName}`)
    formData.append(service?.sourceType, service?.radiology)
    formData.append(
      service?.file,
      blobData,
      `${item?.patientName}_${item?.id}.pdf`
    )

    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${radiologyIntents?.notificationUpload}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      }
    )

    if (response?.status === 200) {
      return response.data
    } else {
      return { fileId: '' }
    }
  } catch (error) {
    console.error(error)
  }
}

export const getAllRadiologyBacklogOrders = async (
  param: string,
  value: string,
  page: number,
  size: number,
  status: string,
  source: string,
  activeOrderStatus: string
) => {
  const active = activeOrderStatus === dropDownMenuKeys?.active ? true : false
  const token = KeycloakService.getToken()
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${radiologySearchEndpoint}?param=${param}&value=${value}&page=${page}&size=${size}&status=${status}&source=${source}&active=${active}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    console.error('Error opening file: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}
export const archiveRadiologyOrder = async (
  data: any,
  activeOrderStatus: any
) => {
  const token = KeycloakService?.getToken()
  const active =
    activeOrderStatus === dropDownMenuKeys?.active
      ? dropDownMenuKeys?.inActive
      : dropDownMenuKeys?.active
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_GATEWAY_URL}${archiveradiology}${data}/${active}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    }
  } catch (error: any) {
    console.log(error?.response?.data?.message)
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}
export const deleteRadiologyOrder = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_GATEWAY_URL}${deleteradiology}${data}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    if (response?.data?.success) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    }
  } catch (error: any) {
    console.log(error?.response?.data?.message)
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}
export const getRadiologyOrdersByPatientId = async (
  patientId: any,
  pageSize: any,
  page: any,
  activeOrderStatus: string
) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${getRadiologyOrdersByUhid}`,
      {
        patientUhid: patientId,
        limit: pageSize,
        offset: page * pageSize,
        active: activeOrderStatus === dropDownMenuKeys?.active ? true : false,
      },
      {
        headers: {
          Authorization: `Bearer ${KeycloakService.getToken()}`,
        },
      }
    )
    if (response?.data?.radiology_orders?.length > 0) {
      return {
        data: response?.data,
        success: true,
        message: 'Fetched Orders Successfully',
      }
    } else {
      return {
        data: [],
        success: false,
        message: 'No Orders Found',
      }
    }
  } catch {
    return {
      data: null,
      success: false,
      message: 'An Error Occured',
    }
  }
}
export const updateradiologyorderInvoice = async (
  origin: any,
  products: any,
  documentId: number,
  orderRef: any,
  muhid: string
) => {
  const state = {
    origin: origin,
    patientUhid: muhid,
    payload: {
      document_type: 'invoice',
      document_id: Number(documentId),
      products_list: products,
      order_ref: orderRef,
      radiology: true,
    },
  }

  try {
    const response = await startSxpProxy(
      LABS_PROJECT_ID,
      'updateradiologyorderInvoice',
      state
    )
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const fetchRadiologyTestPrice = async (
  params: FetchRadiologyTestPriceParams
) => {
  try {
    const response = await getOdooProductPrice({
      selectedLocationId: params?.locationResourceId,
      patient_identifier: params?.patientId,
      partner_id: params?.reqPatnerId || '',
      odootestid: params?.odooTestId,
      pricelist_id: params?.priceList,
      b2b: params?.b2bOrigin,
      reqOdooId: params?.reqPatnerId || '',
      doctor_id: params?.reqDoctorRef || '',
    })

    const rawPrice =
      response?.data?.best_price ?? response?.data?.data?.best_price ?? 0
    const defaultPrice = response?.data?.default_price ?? 0
    const price = Number(rawPrice)
    const pricelistId = response?.data?.pricelist_id
    const discount =
      response?.data?.discount_percent ??
      response?.data?.data?.discount_percent ??
      0

    if (!Number?.isFinite(price)) {
      throw new Error(priceListNotFound)
    }

    return {
      success: true,
      data: {
        price,
        defaultPrice,
        pricelistId,
        discount,
      },
    }
  } catch (e: any) {
    return {
      success: false,
      error: e?.response?.data?.message || e?.message,
    }
  }
}
export const getRadiologyOrdersByPatientIdAndLocation = async (
  patientId: any,
  source: string
) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${getRadiologyOrdersByUhid}?patientId=${patientId}&source=${source}`,
      {
        headers: {
          Authorization: `Bearer ${KeycloakService.getToken()}`,
        },
      }
    )
    if (response?.data?.radiology_orders?.length > 0) {
      return {
        data: response?.data,
        success: true,
        message: 'Fetched Orders Successfully',
      }
    } else {
      return {
        data: [],
        success: false,
        message: 'No Orders Found',
      }
    }
  } catch {
    return {
      data: null,
      success: false,
      message: 'An Error Occured',
    }
  }
}
export const UploadRadiologyDocuments = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${RADIOLOGY_FILE_UPLOAD_ENDPOINT}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    if (response?.data?.success) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    }
  } catch (error: any) {
    console.log(error?.response?.data?.message)
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}

export const getRadiologyDocuments = async (data: any) => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${RADIOLOGY_GET_DOCUMENTS_ENDPOINT}?${data}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    if (response?.data?.success) {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    } else {
      const { data, success, message } = response?.data ?? {}
      return {
        data,
        success,
        message,
      }
    }
  } catch (error: any) {
    console.log(error?.response?.data?.message)
    return {
      success: false,
      data: [],
      message: error?.response?.data?.message,
    }
  }
}
export const getMasterEncounterByPatientId = async (patientId: any) => {
  try {
    const response = await startSxpProxy(IPD_PROJECT_ID, 'getMasterEncounter', {
      patientId,
    })
    return {
      data: response?.data ?? null,
      success: true,
    }
  } catch {
    return {
      data: null,
      success: false,
    }
  }
}
export async function downloadDocument(
  documentId: string | null,
  filename?: string
): Promise<void> {
  if (!documentId) {
    toast.error('Invalid document ID')
    return
  }

  try {
    const downloadUrl = `${process.env.REACT_APP_API_GATEWAY_URL}${process.env.REACT_APP_DMS_FILE_UPLOAD}${documentId}`
    const response = await fetch(downloadUrl, {
      method: 'GET',
    })

    if (!response?.ok) {
      throw new Error(`Error: ${response?.status} ${response?.statusText}`)
    }

    const blob = await response?.blob()
    const blobUrl = URL.createObjectURL(blob)

    // Detect file extension from content-type or URL
    let fileExtension = 'pdf'
    const contentType = blob.type || response.headers.get('content-type')

    if (contentType) {
      const mimeToExtension: Record<string, string> = {
        'application/pdf': 'pdf',
        'image/jpeg': 'jpg',
        'image/jpg': 'jpg',
        'image/png': 'png',
        'image/gif': 'gif',
        'image/webp': 'webp',
        'image/svg+xml': 'svg',
        'video/mp4': 'mp4',
        'video/webm': 'webm',
        'video/ogg': 'ogg',
        'video/avi': 'avi',
        'video/quicktime': 'mov',
      }
      fileExtension = mimeToExtension[contentType] || fileExtension
    }

    // If filename from URL path, extract extension from it
    if (documentId.includes('.')) {
      const urlExtension = documentId.split('.').pop()?.toLowerCase()
      if (urlExtension) fileExtension = urlExtension
    }

    // Create a temporary anchor element to trigger download
    const link = document.createElement('a')
    link.href = blobUrl
    link.download = filename
      ? `${filename}.${fileExtension}`
      : `document_${Date.now()}.${fileExtension}`
    document.body.appendChild(link)
    link.click()

    // Cleanup
    document.body.removeChild(link)
    URL.revokeObjectURL(blobUrl)
  } catch (error) {
    console.error(error)
  }
}

export async function displayDocument(
  documentId: string | null
): Promise<void> {
  if (!documentId) {
    toast.error('Invalid document ID')
    return
  }
  try {
    const downloadUrl = `${process.env.REACT_APP_API_GATEWAY_URL}${process.env.REACT_APP_DMS_FILE_UPLOAD}${documentId}`

    const response = await fetch(downloadUrl, {
      method: 'GET',
    })
    if (!response?.ok) {
      throw new Error(`Error: ${response?.status} ${response?.statusText}`)
    }
    const blob = await response?.blob()
    const blobUrl = URL.createObjectURL(blob)

    const iframe = document.createElement('iframe')
    iframe.src = blobUrl
    iframe.width = '100%'
    iframe.height = '100%'
    iframe.style.border = 'none'

    const newWindow = window.open('', '_blank') as Window
    newWindow.document.body.style.margin = '0'
    newWindow.document.body.appendChild(iframe)
    newWindow.document.title = 'Test Results'
  } catch (error) {
    console.error(error)
  }
}

export const deleteRadiologyDocument = async (
  documentId: string | null,
  muhid: any,
  masterVisitId: string | null
) => {
  if (!documentId) {
    return {
      success: false,
      message: ERROR_DELETE_DOCUMENT,
    }
  }

  const token = KeycloakService?.getToken()

  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_GATEWAY_URL}${DELETE_DOCUMENT_BY_ID}${documentId}&patientId=${muhid}&masterVisitId=${masterVisitId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )

    const { data, success, message } = response?.data ?? {}
    return {
      data,
      success,
      message,
    }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message: error?.response?.data?.message || ERROR_DELETE_DOCUMENT,
    }
  }
}
